import React from "react";
import "./Hero.css"; // Import the CSS file for styling
import Heroimage from "../Assets/Heroimage.png"
import Telegram from "../Assets/Telegram.png"
import Instagram from "../Assets/Instagram.png"
import Linkedin from "../Assets/Linkedin.png"
import Dribbble from "../Assets/Dribbble.png"
import Behance from "../Assets/Behance.png"
import UXUI from "../Assets/UX_UI img 1.png"
import Telegram_hover from "../Assets/Telegram_hover.png"
import Instagram_hover from "../Assets/Instagram_hover.png"
import Linkedin_hover from "../Assets/Linkedin_hover.png"
import Dribbble_hover from "../Assets/Dribbble_hover.png"
import Behance_hover from "../Assets/Behance_hover.png"

function Hero() {
    
  return (
    <section className="hero-section">
        <div className="hero-all-content">
      <div className="hero-content">
        <img
          src={Heroimage} // Replace with the path to your image
          alt="Hero"
          className="hero-image"
        />
        <h1 className="hero-text">Hi, I’m Shokhrukh, a passionate Product Designer who build crafting exceptional designs. My mission is to create products that look great and solve real-world problems.</h1>
        <div className="hero-icons">
          <a href="https://t.me/Shokhdesign_uxui" target="_blank" rel="noopener noreferrer">
            <img
            alt="Icon"
            src={Telegram}
            className="Icon" 
            onMouseEnter={(e) => (e.currentTarget.src = Telegram_hover)}
            onMouseLeave={(e) => (e.currentTarget.src = Telegram)}
            />
          </a>
          <a href="https://www.instagram.com/shohruh_karimqulov/" target="_blank" rel="noopener noreferrer">
            <img
            alt="Icon"
            src={Instagram}
            className="Icon"
            onMouseEnter={(e) => (e.currentTarget.src = Instagram_hover)}
            onMouseLeave={(e) => (e.currentTarget.src = Instagram)} 
            />
          </a>
          <a href="https://www.linkedin.com/in/shohruh-karimqulov-126ab21bb/" target="_blank" rel="noopener noreferrer">
            <img
            alt="Icon"
            src={Linkedin}
            className="Icon"
            onMouseEnter={(e) => (e.currentTarget.src = Linkedin_hover)}
            onMouseLeave={(e) => (e.currentTarget.src = Linkedin)} 
            />
          </a>
          <a href="https://dribbble.com/Shohruh_Karimqulov" target="_blank" rel="noopener noreferrer">
            <img
            alt="Icon"
            src={Dribbble}
            className="Icon" 
            onMouseEnter={(e) => (e.currentTarget.src = Dribbble_hover)}
            onMouseLeave={(e) => (e.currentTarget.src = Dribbble)}
            />
          </a>
          <a href="https://www.behance.net/shohruhkarimqu" target="_blank" rel="noopener noreferrer">
            <img
            alt="Icon"
            src={Behance}
            className="Icon" 
            onMouseEnter={(e) => (e.currentTarget.src = Behance_hover)}
            onMouseLeave={(e) => (e.currentTarget.src = Behance)}
            />
          </a>
        </div>
      </div>
      <img alt="UXUI"
          src={UXUI}
          className="hero-uxui-image" />
      </div>
    </section>
  );
}

export default Hero;
